export interface NO03SearchParams {
  // Internal parameters - will be transformed for backend
  companyId: string; // Required 3-character company ID (e.g., "998")
  customerNumber?: number; // Optional customer number filter
  fromDate?: string; // Date range start (yyyy-MM-dd format)
  toDate?: string; // Date range end (yyyy-MM-dd format)
  invoiceNumber?: string; // Invoice number search (partial match)
  orderNumber?: string; // Order number search (partial match)
  amount?: number; // Amount search (exact match)
  negativeOnly?: boolean; // Amount search: a lone "-" means "credit notes only" (negative amount)
  page?: number; // Pagination - page number (0-based)
  pageSize?: number; // Pagination - number of items per page
}

export interface NO03Invoice {
  kundenr: string;
  kundenavn: string;
  fakturanr: string;
  fakturaKid: string;
  ordre: string;
  fakturadato: string;
  fakturatotal: number;
}

export default class NO03 implements NO03Invoice {
  private _kundenr: string;
  private _kundenavn: string;
  private _fakturanr: string;
  private _fakturaKid: string;
  private _ordre: string;
  private _fakturadato: string;
  private _fakturatotal: number;

  constructor(
    kundenr = '',
    kundenavn = '',
    fakturanr = '',
    fakturaKid = '',
    ordre = '',
    fakturadato = '',
    fakturatotal = 0
  ) {
    this._kundenr = kundenr;
    this._kundenavn = kundenavn;
    this._fakturanr = fakturanr;
    this._fakturaKid = fakturaKid;
    this._ordre = ordre;
    this._fakturadato = fakturadato;
    this._fakturatotal = fakturatotal;
  }

  public get kundenr(): string {
    return this._kundenr;
  }

  public set kundenr(value: string) {
    this._kundenr = value;
  }

  public get kundenavn(): string {
    return this._kundenavn;
  }

  public set kundenavn(value: string) {
    this._kundenavn = value;
  }

  public get fakturanr(): string {
    return this._fakturanr;
  }

  public set fakturanr(value: string) {
    this._fakturanr = value;
  }

  public get fakturaKid(): string {
    return this._fakturaKid;
  }

  public set fakturaKid(value: string) {
    this._fakturaKid = value;
  }

  public get ordre(): string {
    return this._ordre;
  }

  public set ordre(value: string) {
    this._ordre = value;
  }

  public get fakturadato(): string {
    return this._fakturadato;
  }

  public set fakturadato(value: string) {
    this._fakturadato = value;
  }

  public get fakturatotal(): number {
    return this._fakturatotal;
  }

  public set fakturatotal(value: number) {
    this._fakturatotal = value;
  }
}
